import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-main-layout',
  templateUrl: './main-layout.component.html',
  styleUrls: ['./main-layout.component.scss'],
  standalone: false
})
export class MainLayoutComponent {
  @Input() isHome: boolean = false;
  @Input() isLoggedIn: boolean = false;
  @Input() breadcrumbs$: Observable<any>;
  @Input() breadcrumbVariable: Observable<string>;
  @Input() canShowCarousel: boolean = false;

  constructor(private router: Router) {}

  /**
   * Handles breadcrumb selection and navigation.
   * Navigates to the selected breadcrumb URL with its associated params.
   * @param breadcrumb The selected breadcrumb containing url and params
   */
  onSelectBreadcrumb(breadcrumb: any) {
    if (!breadcrumb.params.length) {
      this.router.navigate([breadcrumb.url]);
    } else {
      const array = [];
      array.push(breadcrumb.url);
      breadcrumb.params.map((param) => {
        array.push(param);
      });
      this.router.navigate(array);
    }
  }
}

